import { useState, useEffect, useRef } from 'react';
import { Download, X, Share } from 'lucide-react';

export default function PwaInstallBanner() {
    const [show, setShow] = useState(false);
    const [isIos, setIsIos] = useState(false);
    const deferredPromptRef = useRef(null);

    useEffect(() => {
        // Already installed as PWA
        if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true) return;

        // Dismissed this session
        if (sessionStorage.getItem('pwa-banner-dismissed')) return;

        const ios = /iPhone|iPad|iPod/i.test(navigator.userAgent) && !window.MSStream;
        setIsIos(ios);

        if (ios) {
            setShow(true);
            return;
        }

        const handler = (e) => {
            e.preventDefault();
            deferredPromptRef.current = e;
            setShow(true);
        };

        window.addEventListener('beforeinstallprompt', handler);

        const installedHandler = () => {
            setShow(false);
            deferredPromptRef.current = null;
        };
        window.addEventListener('appinstalled', installedHandler);

        return () => {
            window.removeEventListener('beforeinstallprompt', handler);
            window.removeEventListener('appinstalled', installedHandler);
        };
    }, []);

    const handleInstall = async () => {
        if (!deferredPromptRef.current) return;
        deferredPromptRef.current.prompt();
        const { outcome } = await deferredPromptRef.current.userChoice;
        if (outcome === 'accepted') setShow(false);
        deferredPromptRef.current = null;
    };

    const handleDismiss = () => {
        sessionStorage.setItem('pwa-banner-dismissed', '1');
        setShow(false);
    };

    if (!show) return null;

    return (
        <div
            style={{
                background: 'rgba(245, 158, 11, 0.08)',
                border: '1px solid rgba(245, 158, 11, 0.2)',
                borderRadius: '12px',
                padding: '12px 16px',
                marginBottom: '16px',
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
            }}
        >
            <div
                style={{
                    width: 36, height: 36, borderRadius: '10px',
                    background: 'rgba(245, 158, 11, 0.15)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    flexShrink: 0,
                }}
            >
                <Download size={18} style={{ color: '#f59e0b' }} />
            </div>

            <div style={{ flex: 1, minWidth: 0 }}>
                <p style={{ color: 'var(--text-primary)', fontSize: '13px', fontWeight: 600, margin: 0 }}>
                    Nainstalujte si FofrLama OS
                </p>
                {isIos ? (
                    <p style={{ color: 'var(--text-muted)', fontSize: '11px', margin: '2px 0 0', display: 'flex', alignItems: 'center', gap: '4px', flexWrap: 'wrap' }}>
                        Klepněte na <Share size={12} style={{ color: '#f59e0b' }} /> <strong>Sdílet</strong> a poté <strong>Přidat na plochu</strong>
                    </p>
                ) : (
                    <p style={{ color: 'var(--text-muted)', fontSize: '11px', margin: '2px 0 0' }}>
                        Rychlejší přístup, notifikace a offline režim
                    </p>
                )}
            </div>

            {!isIos && (
                <button
                    onClick={handleInstall}
                    style={{
                        background: 'var(--brand)',
                        color: '#1a1a2e',
                        border: 'none',
                        borderRadius: '8px',
                        padding: '6px 14px',
                        fontSize: '12px',
                        fontWeight: 600,
                        cursor: 'pointer',
                        whiteSpace: 'nowrap',
                        flexShrink: 0,
                    }}
                >
                    Nainstalovat
                </button>
            )}

            <button
                onClick={handleDismiss}
                style={{
                    background: 'transparent',
                    border: 'none',
                    color: 'var(--text-muted)',
                    cursor: 'pointer',
                    padding: '4px',
                    flexShrink: 0,
                    borderRadius: '6px',
                }}
            >
                <X size={16} />
            </button>
        </div>
    );
}
